import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AddressDetailsModalComponent, BottomCheckBoxUI } from './address.details.modal.component';
import { EntityAddress } from './address.model';

@Injectable(
    { providedIn: 'root' }
)
export class AddressDetailsModalLaunchService {
    constructor(
        private modalService: BsModalService
    ) {
    }

    customTemplateModalRef: BsModalRef;

    openAddressDetailsModal(
        entityID: number, 
        entityTypeID: number, 
        entityAddresses: EntityAddress[],
        canEdit: boolean, 
        justSelect?: boolean, 
        checkDeliverability?: boolean,
        defaultCheckboxHeaderOverride?: string,
        bottomCheckBox?: BottomCheckBoxUI
    ): Promise<EntityAddress[]> {
        const promise = new Promise<EntityAddress[]>((resolve) => {
            const initialState = {
                entityID: entityID,
                entityTypeID: entityTypeID,
                entityAddresses: entityAddresses,
                canEdit: canEdit,
                justSelect: justSelect,
                checkDeliverability: checkDeliverability,
                defaultCheckboxHeaderOverride: defaultCheckboxHeaderOverride,
                bottomCheckBox: bottomCheckBox
            };

            const modalRef = this.modalService.show(AddressDetailsModalComponent, {
                initialState,
                class: 'modal-change-history'
            });

            modalRef.content.onClose = (x: EntityAddress[]) => resolve(x);
        });

        return promise;
    }
}
